import NumericStepper from '@vtex/styleguide/lib/NumericStepper';

export function VtexNumericStepper({ ...otherProps }) {
	return <NumericStepper {...otherProps} />;
}
